import React from 'react'
import { withRouter } from "react-router";
import { getCall, baseUrl } from '../../helpers/api'
import CardContainer from './cards/agac-result/card-container/cardContainer'
import CardTitle from './cards/card-title/card-title'
import CardHolder from './cards/card-holder/cardHolder'
import Card from './cards/agac-result/cards/card'
import CardCicek from './cards/result-cards/cards/card'

class SearchPage extends React.Component {

    constructor() {
        super()
        this.state = {
            searching: false,
            searchReturn: {agaclar: [], cicekler: []}
        }
    }

    async componentDidMount() {
        await this.makeSearch()
    }

    async makeSearch() {
        await this.setState({ searching: true })
        const searchValue = window.location.pathname.split('/')[2]
        const search = await getCall("/search/" + searchValue)
        await this.setState({ searchReturn: search.data, searching: false})
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged();
        }
    }

    onRouteChanged() {
        this.makeSearch()
    }

    render() {
        if (this.state.searching) {
            return (
                <CardContainer>
                    <CardTitle title="Aranıyor..." />
                </CardContainer>
            )
        }
        return (
            <CardContainer>
                <CardTitle title="Arama Sonuçları" />

                <CardHolder>
                    {this.state.searchReturn.cicekler.map((r, index) => (
                        <CardCicek key={index} history={this.props.history} id={r._id} image={baseUrl + r.image} name={r.name} />
                    ))}
                </CardHolder>
                <CardHolder>
                    {this.state.searchReturn.agaclar.map((r, index) => (
                        <Card key={index} history={this.props.history} id={r._id} image={baseUrl + r.image} name={r.name} />
                    ))}
                </CardHolder>
            </CardContainer>
        )
    }
}

export default withRouter(SearchPage)